"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIATIVES_NEW_TASK = void 0;
exports.INITIATIVES_NEW_TASK = {
    MAX_LENGTH: 255,
    MAX_MESSAGE: 'Task description cannot exceed 255 characters'
};
//# sourceMappingURL=INITIATIVES_NEW_TASK.js.map